export const environment = {
	production: true,
	clockUrl: "https://test-clock.timecheck.dev",
	apiUrl: "https://test-api.timecheck.dev",
	clockAppUrl: "https://test-clock2.timecheck.dev"
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts